import  * as types from '../actions/ActionTypes';

export interface ModalState {
    modal: boolean,
    content: string
}

export interface Action{
    type: string;
    payload: string;
}

const defaultState : ModalState = {
    modal: false,
    content: '',
};

export function alertModal(state : ModalState = defaultState, action : Action){

    switch(action.type) {
        case types.OPEN_MODAL: {
            return {
                ...state,
                modal: true,
                content: action.payload
            }
        }
        case types.CLOSE_MODAL: {
            return {
                ...state,
                modal: false,
                content: '',
            }
        }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/alertModal.tsx